import script from "./LaboratoryCard.vue?vue&type=script&setup=true&lang=js"
export * from "./LaboratoryCard.vue?vue&type=script&setup=true&lang=js"

import "./LaboratoryCard.vue?vue&type=style&index=0&id=349d5822&lang=css"

const __exports__ = script;

export default __exports__